<template>
    <div>
        <h1 class="subtitle">Orden: {{code}}</h1>
        <button class="button is-success" @click="restart">Reiniciar Estado</button>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "OrdenRestart",
        data(){
            return {
                code:'',
                id: ''
            }
        },
        methods: {
            restart(){
                axios.post('/orden/restart',{},{idOrden: this.id}).then(
                    () => {
                        this.$buefy.snackbar.open({
                            message: 'Orden Reiniciada',
                            type: 'is-success',
                            position: 'is-top',
                            actionText: 'OK',
                            indefinite: true
                        })
                    }
                )
            }
        },
        mounted() {
            this.code = new URLSearchParams(window.location.search).get('code');
            let path = window.location.pathname;
            this.id = path.split("/")[3];
        }
    }
</script>

<style scoped>

</style>
